module.exports = __webpack_public_path__ + "static/media/logo-black.246524fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-black.png
// module id = 112
// module chunks = 0